<template>
    <div class="patient-coaching-summary-wbi">
        <b-row class="align-content-around">
            <div class="report-widget col text-center">
                <b-row>
                    <b-col>
                        <label>
                            {{ $i18n.gt('HEADING_WBI_SCORE') }}
                        </label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn class="col btn-sm" variant="primary" @click.stop="showWbiModal()">
                            {{ $i18n.gt('LABEL_VIEW_BUTTON') }}
                        </b-btn>
                    </b-col>
                </b-row>

            </div>
        </b-row>
        <b-modal :id="modalId" :title="$i18n.gt('HEADING_WBI_SCORE')" hide-footer size="md">
            <report-widget widget-key="WBI_SCORE" :enable-modal="false"/>
            <report-widget-wbi-breakdown/>
        </b-modal>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: 'PatientCoachingSummaryWbi',
        computed: {
            participant() {
                return this.$store.state.patientParticipant
            },
            modalId() {
                return 'modal_wbi'
            },
        },
        data() {
            return {
            }
        },
        methods: {
            showWbiModal() {
                this.$bvModal.show(this.modalId)
            }
        }
    })
</script>

<style lang="scss">

    .report-widget {
        cursor: pointer;

        .card {
            background: #fff;
            transition: all .3s;
            margin-bottom: 0;
            @media(min-width: 540px) {
                height: 100%;
            }

            &:hover {
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);

                .report-widget__timestamp {
                    color: var(blue);
                }
            }
        }

        @media(max-width: 719px) {
            margin-bottom: 1rem;
        }

    }
</style>
